import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const Mississippi = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Mississippi Specific Terms</Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. Seller's Disclosure Statement: Recommended but not mandatory.
        </Text>

        <Text style={styles.listItem}>
          2. Attorney Involvement: Common for closing.
        </Text>

        <Text style={styles.listItem}>
          3. <Text style={styles.underline}>Lead-Based Paint Disclosure</Text> –
          Only for residences that were built before 1978. This information
          should be available at the County's Revenue Office.
        </Text>

        <Text style={styles.listItem}>
          4.{' '}
          <Text style={styles.underline}>
            Seller's Property Disclosure Statement
          </Text>{' '}
          – Sellers must provide details about the property's utilities and
          condition, with buyers having three days to terminate their offer if
          the disclosure comes after an offer is made.
        </Text>
      </View>
    </View>
  );
};

export default Mississippi;
